import React, {
  useEffect, useState, Fragment, useMemo,
} from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Tooltip, Popconfirm, Dropdown, Checkbox, Select, Tag, notification,
  Divider,
  Drawer,
} from 'antd';
import {
  FilterOutlined, FileProtectOutlined, ControlOutlined, ExclamationCircleFilled, UpCircleTwoTone,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import H3Text from '@Uilib/h3Text';
import CNActions from '@Actions/cnActions';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { toISTDate } from '@Apis/constants';
import UnicommerceIntegrationActions from '@Actions/integrations/unicommerceIntegrationActions';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';
import ucIcon from '@Images/icons/unicommerce-icon.png';
import ZohoBooks from '@Images/admin/integrations/zoho-books.png';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3DateSelector from '@Uilib/h3DateSelector';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import SelectDepartment from '@Components/Common/SelectDepartment';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import TenantActions from '@Actions/tenantActions';
import SelectUser from '@Components/Common/SelectUser';
import Busy from '@Images/admin/integrations/busy.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import BusyIntegrationActions from '../../../../actions/integrations/busyIntegrationAction';
import documentUINamesConstant from '../../../../apis/documentUINamesConstant';
import HideValue from '../../../Common/RestrictedAccess/HideValue';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import ListScreenKeys from './mobileListHelper';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';

const { Option } = Select;

function CreditNoteList({
  creditNotes, getCNLoading, user, getCN, history, syncSOLoading, syncSO, getDocCFV2, MONEY,
  getDocCFV2Success, getDocCFV2Loading, customFieldsProps, departments, syncCN, syncCNLoading, syncTallyCreditNoteLoading, syncTallyCreditNote, getOrgUsers, orgUsers, pushCreditNoteToBusy, pushCreditNoteToBusyLoading, priceMasking, customFieldsPropsReturnSlip,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [fixedColumns, setFixedColumns] = useState(['CREDIT_NOTE_NO']);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const isReturnSlip = useMemo(() => window.location.href.includes('/return-slip'), []);

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  const defaultColumns = {
    CREDIT_NOTE_NO: {
      label: `${isReturnSlip ? 'Return Slip#' : 'Credit Note#'}`,
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    SALES_ORDER_NO: {
      label: `${isReturnSlip ? 'AMC SO' : documentUINames.salesOrderUIName}#`,
      visible: true,
    },
    INVOICE_NO: {
      label: `${isReturnSlip ? 'Consumption Order#' : 'Invoice#'}`,
      visible: true,
    },
    CUSTOMER: {
      label: 'Customer',
      visible: true,
    },
    ITEMS: {
      label: 'Items',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    CN_DATE: {
      label: 'Credit Date',
      visible: false,
    },
    REASON: {
      label: 'Reason',
      visible: false,
    },
    STATUS: {
      label: 'Status',
      visible: true,
    },
    SALES_MANAGER: {
      label: 'Sales Manager',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
  };
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [departmentLevelVisibility, setDepartmentLevelVisibility] = useState(false);
  const [selectedAssignee, setSelectedAssignee] = useState([]);
  const cnStatuses = [
    { value: 'DRAFT', label: 'Draft' },
    { value: 'CONFIRMED', label: 'Confirmed' },
    { value: 'VOID', label: 'Void' },
  ];

  if (!isReturnSlip) {
    defaultColumns.AMOUNT_WITHOUT_TAX = {
      label: 'Amount (Without Tax)',
      visible: false,
    };
    defaultColumns.TAXES = {
      label: 'Taxes',
      visible: false,
    };
    defaultColumns.AMOUNT_WITH_TAX = {
      label: 'Total Amount',
      visible: true,
    };
  }

  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-cn') ? JSON.parse(localStorage.getItem('prcz-page-columns-cn')) : defaultColumns);

  const [selectedCreditNote, setSelectedCreditNote] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);

  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit')) || limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'department_id',
        filter_value: Number(Helpers.getValueFromUrl('department_id')) || '',
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'accountManager',
        filter_value: Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
          userId: parseInt(item),
          title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
          identity: parseInt(item) == 0 ? 'UA' : orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        })) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'status',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'tenant',
      filter_value: [user?.tenant_info?.tenant_id],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'startDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'endDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'department_id',
      filter_value: Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility ? Number(Helpers.getDepartmentId(user)) : '',
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'accountManager',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
  ], []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: window.location.href.includes('/return-slip') ? entityNameEnum.RETURN_SLIP : entityNameEnum.CREDIT_NOTE,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  const getCreditNoteColumns = () => {
    const tableColumns = [
      // {
      //   title: '',
      //   render: (record) => (
      //     <Link to={`/sales/${isReturnSlip ? 'return-slip' : 'credit-note'}/view/${record.cn_id}`}>
      //       <div className="mobile-list__item">
      //         <div className='flex-display'>
      //           <H3Text text={`#${record?.credit_note_number}`} className="mobile-list__item-number" />
      //           <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
      //             {Helpers.getStatusColor(record.status).text?.toUpperCase()}
      //           </div>
      //         </div>
      //         {record?.customer_info && (
      //           <div className="mobile-list__item-info">
      //             {`Customer - ${record?.customer_info?.customer_name}`}
      //           </div>
      //         )}
      //         {record?.invoice_id && <H3Text text={`Invoice Number - ${record?.invoice_number}`} className="mobile-list__item-info" />}
      //         <H3Text text={`Amount - ${MONEY((record?.cn_grand_total || '0'), record?.org_currency_info?.currency_code)}`} className="mobile-list__item-info" />
      //         <H3Text text={`Created by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" />
      //       </div>
      //     </Link>
      //   ),
      //   responsive: ['xs'],
      // },
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <Link
                // to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
                >
                  <PRZText
                    text={`#${record?.credit_note_number}`}
                    className="mobile-list__card_item-number"
                  />
                </Link>
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  className="mobile-list__card__status"
                  style={{
                    backgroundColor: Helpers.getStatusColor(record.status).color,
                  }}
                  text={Helpers.getStatusColor(record.status).text}
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                {record?.customer_info?.customer_name ? (
                  <div className="mobile-list__card_item-name_wrapper">
                    <Tooltip
                      title={
                        Helpers.getPermission(Helpers.permissionEntities.CUSTOMER,
                          Helpers.permissionTypes.READ, user)
                          ? (
                            <Link
                            // to={`/sales/customer/view/${record?.customer_id}`} target="_blank"
                            >
                              <PRZText
                                className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                                text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                              />
                            </Link>
                          ) : (
                            <PRZText
                              className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                              text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                            />
                          )
                      }
                      color="white"
                    >
                      <PRZText text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`} className="mobile-list__card_item-name" />
                    </Tooltip>
                  </div>
                ) : '-'}

                <PRZText text={`${isReturnSlip ? 'Return Slip Date' : 'Credit Date'}: ${toISTDate(record?.cn_date).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details" />

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${record?.tenant_info?.tenant_name}`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Location: ${record?.tenant_info?.tenant_name}`} className="mobile-list__card_item-details" />
                </Tooltip>

                {/* <PRZText text={`Sales Manager: ${record?.account_manager_info?.account_manager_id ? (`${record?.account_manager_info?.first_name} ${record?.account_manager_info?.last_name}`) : 'N/A'}`} className="mobile-list__card_item-details" /> */}

                {record?.order_id
                  && (
                    <PRZText
                      text={(
                        <React.Fragment>
                          <span>
                            {isReturnSlip ? 'AMC SO' : documentUINames.salesOrderUIName}
                            #:
                            {' '}
                          </span>
                          <span>
                            {
                              ((isReturnSlip && Helpers.getPermission(Helpers.permissionEntities.ANNUAL_MAINTENANCE_CONTRACT, Helpers.permissionTypes.READ, user))
                                || (!isReturnSlip && Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user))) ? (
                                <React.Fragment>
                                  {
                                    record?.order_id ? (
                                      <Link
                                      // to={
                                      //   isReturnSlip
                                      //     ? `/sales/amc-sales-order/view/${record?.order_id}`
                                      //     : `/sales/sales-order/view/${record?.order_id}`
                                      // }
                                      // target="_blank"
                                      >
                                        {record?.sales_order_number}
                                      </Link>
                                    ) : '-'
                                  }
                                </React.Fragment>
                              ) : record?.order_id || ''
                            }
                          </span>
                        </React.Fragment>
                      )}
                      className="mobile-list__card_item-details"
                    />
                  )}

                {record?.invoice_id
                  && (
                    <PRZText
                      text={(
                        <React.Fragment>
                          <span>
                            {isReturnSlip ? 'Consumption Order Number' : 'Invoice Number'}
                            :
                            {' '}
                          </span>
                          <span>
                            {
                              (isReturnSlip
                                ? Helpers.getPermission(
                                  Helpers.permissionEntities.CONSUMPTION_ORDER,
                                  Helpers.permissionTypes.READ,
                                  user,
                                )
                                : Helpers.getPermission(
                                  Helpers.permissionEntities.INVOICE,
                                  Helpers.permissionTypes.READ,
                                  user,
                                )
                              )
                                ? (
                                  <React.Fragment>
                                    {
                                      record?.invoice_id ? (
                                        <Link
                                        // to={
                                        //   isReturnSlip
                                        //     ? `/sales/consumption/view/${record?.invoice_id}`
                                        //     : `/sales/invoice/view/${record?.invoice_id}`
                                        // }
                                        // target="_blank"
                                        >
                                          {record?.invoice_number}
                                        </Link>
                                      ) : '-'
                                    }
                                  </React.Fragment>
                                ) : record?.invoice_id || ''
                            }
                          </span>
                        </React.Fragment>
                      )}
                      className="mobile-list__card_item-details"
                    />
                  )}

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${record.reason}`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Reason: ${record.reason}`} className="mobile-list__card_item-details" />
                </Tooltip>

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${toISTDate(record?.created_at).format('DD/MM/YYYY')} ( ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'})`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Created By ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details created_by_info" />
                </Tooltip>

              </div>
              <div className="mobile-list__card_body-right">
                {!isReturnSlip && (
                  <React.Fragment>
                    <Tooltip
                      color="white"
                      title={(
                        <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Amount Without Tax" />
                      )}
                    >
                      <PRZText
                        text={(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={'You don\'t have access to view amount without tax'} /> : MONEY((record?.cn_base_price || '0'), record?.org_currency_info?.currency_code)}
                        className="mobile-list__card_item-details"
                      />
                    </Tooltip>
                    <Tooltip
                      color="white"
                      title={(
                        <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Taxes" />
                      )}
                    >
                      <PRZText
                        text={MONEY((record?.cn_taxes || '0'), record?.org_currency_info?.currency_code)}
                        className="mobile-list__card_item-details"
                      />
                    </Tooltip>
                    <Tooltip
                      color="white"
                      title={(
                        <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Amount" />
                      )}
                    >
                      <PRZText
                        text={(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={'You don\'t have access to view amount'} /> : MONEY((record?.cn_grand_total || '0'), record?.org_currency_info?.currency_code)}
                        className="mobile-list__card_item-details"
                      />
                    </Tooltip>
                  </React.Fragment>
                )}
                {/* <div className="mobile-list__card_item_status_wrapper">
                  <Tooltip
                    color="white"
                    title={(
                      <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Payment Status" />
                    )}
                  >
                    <PRZText
                      className="mobile-list__card_item_status"
                      style={{ color: Helpers.getStatusColor(record?.payment_status)?.color }}
                      text={record.payment_status?.replaceAll('_', ' ')?.toProperCase()}
                    />
                  </Tooltip>
                </div> */}
              </div>
            </div>

            <Divider className="mobile-list__card_divider" />

            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <div className="mobile-list__card_footer__actions-button_wrapper">
                  <div className="card_footer__actions-button">
                    {['CONFIRMED'].includes(record.status) && record?.busy_location_name && !isReturnSlip && (
                      <Popconfirm
                        title={(record?.busy_sync_error ? record?.busy_sync_error : (<React.Fragment>{record?.busy_voucher_id ? 'Credit Note is already synced with Busy' : 'Credit Note is not synced with Busy'}</React.Fragment>))}
                        onConfirm={() => pushCreditNoteToBusy(
                          { cn_id: record?.cn_id },
                          () => getCN(user?.tenant_info?.tenant_id, '', currentPage, limit, '', keyword, null, null, null, null, null, null, true),
                        )}
                        okText={(!record?.busy_sync_error && !record?.busy_voucher_id) ? 'Sync' : 'Sync Again'}
                        okButtonProps={{
                          loading: pushCreditNoteToBusyLoading,
                        }}
                        cancelText="Cancel"
                        icon={record?.busy_sync_error ? <ExclamationCircleFilled style={{ color: '#F2BD27' }} /> : <React.Fragment />}
                      >
                        <div className="img-busy__wrapper card_footer__actions-button_image__wrapper">
                          <img
                            src={Busy}
                            alt="busy"
                            className="img-busy card_footer__actions-button_image"
                          />
                          {(!record?.busy_sync_at || record?.busy_sync_error) && <div className={`busy-corner-icon actions-button__corner-icon  ${record?.busy_sync_error && 'red-indicator'}`}>{!record?.busy_sync_error && <UpCircleTwoTone style={{ fontSize: '10px' }} twoToneColor="#52c41a" />}</div>}
                        </div>
                      </Popconfirm>
                    )}
                  </div>
                  {record?.unicommerce_so_code && !isReturnSlip && (
                    <Popconfirm
                      title={`This ${documentUINames.salesOrderUIName} was last synced on ${record?.unicommerce_last_sync && toISTDate(record?.unicommerce_last_sync).format('DD/MM/YYYY hh:mm A')}`}
                      onConfirm={() => {
                        syncSO({
                          tenant_id: user?.tenant_info?.tenant_id,
                          unicommerce_so_codes: [
                            record?.unicommerce_so_code,
                          ],
                        }, () => {
                          getCN(user?.tenant_info?.tenant_id, '', currentPage, limit, '', keyword, null, null, null, null, null, null, true);
                        });
                      }}
                      okText="Sync Again"
                      cancelText="No"
                    >
                      <div className="card_footer__actions-button">
                        <div className="card_footer__actions-button_image__wrapper">
                          <img
                            alt="unicommerce"
                            className="unicommerce-button card_footer__actions-button_image"
                            src={ucIcon}
                          />
                        </div>
                      </div>
                    </Popconfirm>
                  )}

                  {user?.tenant_info?.zoho_branch_id && user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id && !isReturnSlip && (
                    <div className="card_footer__actions-button">
                      {
                        record?.status === 'CONFIRMED' && (
                          <Fragment>
                            {(record?.zoho_cn_id)
                              ? (
                                <Tooltip
                                  title={toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}
                                  overlayClassName="font-12"
                                >
                                  <a
                                    href={`https://books.zoho.in/app#/creditnotes/${record?.zoho_cn_id}`}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                                      <img
                                        style={{
                                          width: '18px',
                                          height: '18px',
                                        }}
                                        src={ZohoBooks}
                                        alt="Zoho"
                                        className="img-zoho card_footer__actions-button_image"
                                      />
                                      <div className="green-indicator" />
                                    </div>
                                  </a>
                                </Tooltip>
                              )
                              : (
                                <div>
                                  {!['SENT_FOR_APPROVAL', 'DRAFT', 'VOID', 'CANCELLED'].includes(record?.status) && (
                                    <Popconfirm
                                      title={(record?.zoho_warning_message === null || record?.zoho_warning_message === '') ? 'This Credit Note is not synced with Zoho Books.' : `${record?.zoho_warning_message}`}
                                      onConfirm={() => syncCN(
                                        { cn_id: record?.cn_id },
                                        () => getCN(selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.CREDIT_NOTE, Helpers.permissionTypes.READ)?.join(','), '', Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), '', Helpers.getValueFromUrl('keyword'), Helpers.getValueFromUrl('status'),
                                          Helpers.getValueFromUrl('startDate'), Helpers.getValueFromUrl('endDate'), Helpers.getValueFromUrl('department_id')), null, null, true
                                      )}
                                      okText="Sync again"
                                      okButtonProps={{
                                        loading: syncCNLoading,
                                      }}
                                      cancelText="Cancel"
                                    >
                                      <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                                        <img
                                          style={{
                                            width: '18px',
                                            height: '18px',
                                          }}
                                          src={ZohoBooks}
                                          alt="Zoho"
                                          className="img-zoho img-zoho__disabled card_footer__actions-button_image"
                                        />
                                        <div className="green-indicator red-indicator" />
                                      </div>
                                    </Popconfirm>
                                  )}
                                </div>
                              )}
                          </Fragment>
                        )
                      }
                    </div>
                  )}
                </div>
              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedCreditNote(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: `${isReturnSlip ? 'RS #' : 'CN #'}`,
        render: (record) => (
          <div className="column-number__wrapper min-width-50">
            <div className="flex-display">
              <H3Text text={record?.credit_note_number} />
              {user?.tenant_info?.sales_config?.addons?.e_invoicing?.is_active && user?.user_tenants?.find((tenant) => record?.tenant_id === tenant?.tenant_id)?.is_e_way_bill_enabled && record?.doc_type !== 'RETURN_SLIP' && (
                <Tooltip
                  title={record?.e_invoice_status === 'PUSHED' ? 'Credit Note pushed to IRP' : 'Credit Note yet-to-be pushed to IRP'}
                >
                  <div
                    style={{ color: record?.e_invoice_status === 'PUSHED' ? '#52c41a' : '#ee3a49' }}
                    className="irp-status"
                  >
                    <FileProtectOutlined />
                  </div>
                </Tooltip>
              )}
            </div>
            {user?.tenant_info?.sales_config?.addons?.e_invoicing?.is_active && user?.user_tenants?.find((tenant) => record?.tenant_id === tenant?.tenant_id)?.is_e_way_bill_enabled && record?.e_invoice_status === 'PUSHED' && (
              <span
                className="irn-action"
                onClick={() => {
                  navigator.clipboard.writeText(record?.irn);
                  notification.success({
                    message: 'IRN Copied',
                    placement: 'top',
                    duration: 4,
                  });
                }}
              >
                Copy IRN
              </span>
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREDIT_NOTE_NO?.visible ? 'display-none' : '',
        fixed: 'left',
      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_info?.tenant_name} />
            <H3Text text={record?.tenant_department_alias_name} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: `${isReturnSlip ? 'AMC SO' : documentUINames.salesOrderUIName}#`,
        render: (text, record) => (
          <div className="associated-entity  min-width-50">
            {
              ((isReturnSlip && Helpers.getPermission(Helpers.permissionEntities.ANNUAL_MAINTENANCE_CONTRACT, Helpers.permissionTypes.READ, user)) ||
                (!isReturnSlip && Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user)))
                ? (
                  <React.Fragment>
                    {
                      record?.order_id ? (
                        <Link
                          to={
                            isReturnSlip
                              ? `/sales/amc-sales-order/view/${record?.order_id}`
                              : `/sales/sales-order/view/${record?.order_id}`
                          }
                          target="_blank"
                        >
                          {record?.sales_order_number}
                        </Link>
                      ) : '-'
                    }
                  </React.Fragment>
                )
                : (record?.order_id || '')
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SALES_ORDER_NO?.visible ? 'display-none' : '',
      },
      {
        title: `${isReturnSlip ? 'CONSUMPTION ORDER NUMBER' : 'INVOICE NUMBER'}`,
        render: (text, record) => (
          <div className="associated-entity min-width-100">
            {
              (
                isReturnSlip
                  ? Helpers.getPermission(
                    Helpers.permissionEntities.CONSUMPTION_ORDER,
                    Helpers.permissionTypes.READ,
                    user,
                  )
                  : Helpers.getPermission(
                    Helpers.permissionEntities.INVOICE,
                    Helpers.permissionTypes.READ,
                    user,
                  )
              )
                ? (
                  <React.Fragment>
                    {
                      record?.invoice_id ? (
                        <Link
                          to={
                            isReturnSlip
                              ? `/sales/consumption/view/${record?.invoice_id}`
                              : `/sales/invoice/view/${record?.invoice_id}`
                          }
                          target="_blank"
                        >
                          {record?.invoice_number}
                        </Link>
                      ) : '-'
                    }
                  </React.Fragment>
                )
                : (record?.invoice_id || '-')
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.INVOICE_NO?.visible ? 'display-none' : '',
      },
      {
        title: 'CUSTOMER',
        render: (text, record) => (
          <div className="associated-entity min-width-70">
            {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER, Helpers.permissionTypes.READ, user)
              ? (
                <React.Fragment>
                  {record?.customer_info?.customer_name ? (
                    <Link to={`/sales/customer/view/${record?.customer_id}`} target="_blank">
                      {`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                    </Link>
                  ) : '-'}
                </React.Fragment>
              ) : (`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CUSTOMER?.visible ? 'display-none' : '',
      },
      {
        title: 'SALES MANAGER',
        render: (text, record) => (
          <div className="min-width-115">
            {record?.account_manager_info?.account_manager_id ? (`${record?.account_manager_info?.first_name} ${record?.account_manager_info?.last_name}`) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SALES_MANAGER?.visible ? 'display-none' : '',
      },
      {
        title: 'ITEMS',
        render: (text, record) => (
          <div className="min-width-50">
            {record.cn_lines_count}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ITEMS?.visible ? 'display-none' : '',
      },
      {
        title: 'AMOUNT WITHOUT TAX',
        render: (text, record) => (
          <div className="column-amount min-width-150">
            {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view amount without tax" /> : MONEY((record.cn_base_price || '0'), record?.org_currency_info?.currency_code)}
          </div>
        ),
        hidden: isMobile || isReturnSlip,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        className: !visibleColumns?.AMOUNT_WITHOUT_TAX?.visible ? 'display-none' : '',
      },
      {
        title: 'TAXES',
        render: (text, record) => (
          <div className="column-amount min-width-50">
            {MONEY((record.cn_taxes || '0'), record?.org_currency_info?.currency_code)}
          </div>
        ),
        hidden: isMobile || isReturnSlip,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        className: !visibleColumns?.TAXES?.visible ? 'display-none' : '',
      },
      {
        title: 'AMOUNT',
        render: (record) => (
          <div className="column-amount min-width-70">
            {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view amount" /> : MONEY((record?.cn_grand_total || '0'), record?.org_currency_info?.currency_code)}
          </div>
        ),
        hidden: isMobile || isReturnSlip,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        className: !visibleColumns?.AMOUNT_WITH_TAX?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        render: (record) => (
          <div>
            <div className="column-date min-width-100">
              {toISTDate(record?.created_at).format('DD/MM/YYYY')}
            </div>
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: ` ${isReturnSlip ? 'RETURN SLIP DATE' : 'CREDIT DATE'}`,
        render: (text, record) => (
          <div className="column-date min-width-85">
            {toISTDate(record?.cn_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CN_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'REASON',
        render: (item) => (
          <div className="min-width-70">
            {item.reason}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.REASON?.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: 'STATUS',
        render: (item) => (
          <div className="qr__status min-width-70" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>
            {Helpers.getStatusColor(item.status).text}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.STATUS?.visible ? 'display-none' : '',
      },
    ];
    if (isReturnSlip ? customFieldsPropsReturnSlip?.data?.document_custom_fields?.length : customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = isReturnSlip ? customFieldsPropsReturnSlip?.data?.document_custom_fields : customFieldsProps?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.map((custom) => {
        tableColumns.push({
          title: custom.field_name?.toUpperCase(),
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record.custom_fields?.filter((subItem) => subItem.cf_id === custom.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    tableColumns.push({
      title: '',
      render: (text, record) => (
        <div className="list__actions">
          {/* {(record?.tally_updated_at)
            ? (
              <Tooltip
                title={`Last updated at ${toISTDate(record?.tally_updated_at).format('DD/MM/YYYY hh:mm A')}`}
                overlayClassName="font-12"
                placement="topRight"
              >
                <div className="list__actions-button img-tally_credit-note-wrapper">
                  <img
                    src={TallyPrime}
                    alt="Tally"
                    className="img-tally_credit-note"
                  />
                  <div className="green-indicator" />
                </div>
              </Tooltip>
            )
            : (
              <div>
                <Popconfirm
                  placement="topRight"
                  title={record?.tally_warning_message || 'This Credit Note is not synced with Tally.'}
                  onConfirm={() => syncTallyCreditNote(
                    { cn_id: record?.cn_id },
                    () => getCN(user?.tenant_info?.tenant_id, '', currentPage, limit, '', keyword, null, null, null, null, null, null, true),
                  )}
                  okText="Sync again"
                  okButtonProps={{
                    loading: syncTallyCreditNoteLoading,
                  }}
                  cancelText="Cancel"
                >
                  <div className="list__actions-button img-tally_grn-wrapper">
                    <img
                      src={TallyPrime}
                      alt="Tally"
                      className="img-tally_credit-note img-tally_credit-note-disabled"
                    />
                    <div className="green-indicator red-indicator" />
                  </div>
                </Popconfirm>
              </div>
            )} */}
          <div className="list__actions-button img-busy__wrapper">
            {['CONFIRMED'].includes(record.status) && record?.busy_location_name && !isReturnSlip && ( //not needed for rs
              <Popconfirm
                placement="topRight"
                title={(record?.busy_sync_error ? record?.busy_sync_error : (record?.busy_voucher_id ? 'Credit Note is already synced with Busy' : 'Credit Note is not synced with Busy'))}
                onConfirm={() => pushCreditNoteToBusy(
                  { cn_id: record?.cn_id },
                  () => getCN(user?.tenant_info?.tenant_id, '', currentPage, limit, '', keyword, null, null, null, null, null, null, true),
                )}
                okText={(!record?.busy_sync_error && !record?.busy_voucher_id) ? 'Sync' : 'Sync Again'}
                okButtonProps={{
                  loading: pushCreditNoteToBusyLoading,
                }}
                cancelText="Cancel"
                icon={record?.busy_sync_error ? <ExclamationCircleFilled style={{ color: '#F2BD27' }} /> : <React.Fragment />}
              >

                <img
                  src={Busy}
                  alt="busy"
                  className="img-busy"
                />
                {(!record?.busy_sync_at || record?.busy_sync_error) && <div className={`busy-corner-icon  ${record?.busy_sync_error && 'red-indicator'}`}>{!record?.busy_sync_error && <UpCircleTwoTone twoToneColor="#52c41a" />}</div>}
              </Popconfirm>
            )}
          </div>
          {record?.unicommerce_so_code && !isReturnSlip && (
            <Popconfirm
              placement="topRight"
              title={`This ${documentUINames.salesOrderUIName} was last synced on ${record?.unicommerce_last_sync && toISTDate(record?.unicommerce_last_sync).format('DD/MM/YYYY hh:mm A')}`}
              onConfirm={() => {
                syncSO({
                  tenant_id: user?.tenant_info?.tenant_id,
                  unicommerce_so_codes: [
                    record?.unicommerce_so_code,
                  ],
                }, () => {
                  getCN(user?.tenant_info?.tenant_id, '', currentPage, limit, '', keyword, null, null, null, null, null, null, true);
                });
              }}
              okText="Sync Again"
              cancelText="No"
            >
              <div className="list__actions-button">
                <img
                  alt="unicommerce"
                  className="unicommerce-button"
                  src={ucIcon}
                />
              </div>
            </Popconfirm>
          )}

          {user?.tenant_info?.zoho_branch_id && user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id && !isReturnSlip && (
            <div className="list__actions-button">
              {
                record?.status === 'CONFIRMED' && (
                  <Fragment>
                    {(record?.zoho_cn_id)
                      ? (
                        <Tooltip
                          title={toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}
                          overlayClassName="font-12"
                          placement="topRight"
                        >
                          <a
                            href={`https://books.zoho.in/app#/creditnotes/${record?.zoho_cn_id}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <div className="img-zoho__wrapper">
                              <img
                                src={ZohoBooks}
                                alt="Zoho"
                                className="img-zoho"
                              />
                              <div className="green-indicator" />
                            </div>
                          </a>
                        </Tooltip>
                      )
                      : (
                        <div>
                          {!['SENT_FOR_APPROVAL', 'DRAFT', 'VOID', 'CANCELLED'].includes(record?.status) && (
                            <Popconfirm
                              placement="topRight"
                              title={(record?.zoho_warning_message === null || record?.zoho_warning_message === '') ? 'This Credit Note is not synced with Zoho Books.' : `${record?.zoho_warning_message}`}
                              onConfirm={() => syncCN(
                                { cn_id: record?.cn_id },
                                () => getCN(selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.CREDIT_NOTE, Helpers.permissionTypes.READ)?.join(','), '', Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), '', Helpers.getValueFromUrl('keyword'), Helpers.getValueFromUrl('status'),
                                  Helpers.getValueFromUrl('startDate'), Helpers.getValueFromUrl('endDate'), Helpers.getValueFromUrl('department_id'), null, null, true),
                              )}
                              okText="Sync again"
                              okButtonProps={{
                                loading: syncCNLoading,
                              }}
                              cancelText="Cancel"
                            >
                              <div className="img-zoho__wrapper">
                                <img
                                  src={ZohoBooks}
                                  alt="Zoho"
                                  className="img-zoho img-zoho__disabled"
                                />
                                <div className="green-indicator red-indicator" />
                              </div>
                            </Popconfirm>
                          )}
                        </div>
                      )}
                  </Fragment>
                )
              }
            </div>
          )}
          {!isPortrait && (
            <div className="list__actions-button list__actions-button-dark" style={{ width: '100%' }} onClick={() => history.push(`${isReturnSlip ? `/sales/return-slip/view/${record.cn_id}` : `/sales/credit-note/view/${record.cn_id}`}`)}>
              View
            </div>
          )}
        </div>
      ),
      className: 'list__actions-column',
      fixed: 'right',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
    });
    return tableColumns?.filter((column) => !column.hidden);
  };

  const pushParamsToUrl = (page, currentLimit, word, status, currentTenant, currentStartDate, currentEndDate, currentDepartment, accountManager, orderDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (currentLimit) url += `&limit=${currentLimit}`;
    if (word) url += `&keyword=${word}`;
    if (status) url += `&status=${status}`;
    if (currentTenant.length > 0) url += `&tenant=${currentTenant}`;
    if (currentStartDate) url += `&startDate=${currentStartDate}`;
    if (currentEndDate) url += `&endDate=${currentEndDate}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    if (currentDepartment) url += `&department_id=${currentDepartment}`;
    if (accountManager) url += `&accountManager=${selectedAssignee?.map((item) => (item?.userId))?.join(',')}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };
  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.CREDIT_NOTE, Helpers.permissionTypes.READ)?.join(','), (orgUsersData) => {
        // setSelectedAssignee(Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
        //   userId: parseInt(item),
        //   title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
        //   identity: parseInt(item) == 0 ? 'UA' : orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        // })) : []);
      });
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setLimit(Helpers.getValueFromUrl('limit') || limit);
      // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      // setKeyword(Helpers.getValueFromUrl('keyword'));
      // setSelectedStatus(Helpers.getValueFromUrl('status'));
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [user?.tenant_info?.tenant_id]);
      // setStartDate(Number(Helpers.getValueFromUrl('startDate')));
      // setEndDate(Number(Helpers.getValueFromUrl('endDate')));
      // setSelectedAssignee(Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
      //   userId: parseInt(item),
      //   title: `${orgUsers?.data?.find((i) => item?.user_id === parseInt(item))?.first_name}`?.trim(),
      //   identity: orgUsers?.data?.find((i) => item?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
      // })) : []);
      // if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
      //   setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
      //   setSelectedDepartment(Helpers.getValueFromUrl('department_id') || Helpers.getDepartmentId(user)?.toString());
      // } else {
      //   setSelectedDepartment(Helpers.getValueFromUrl('department_id'));
      // }
      // setIsUserReady(true);

      setSelectedFilterView(systemDefaultUserView);
    }
    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }

        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedStatus(tempFilterValues.status);
        setSelectedTenant(tempFilterValues.tenant);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setSelectedAssignee(tempFilterValues.accountManager);
        setSelectedDepartment(tempFilterValues.department_id);

        if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
          setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
          // setSelectedDepartment(Helpers.getValueFromUrl('department_id') || Helpers.getDepartmentId(user)?.toString());
        } else {
          // setSelectedDepartment(Helpers.getValueFromUrl('department_id'));
        }
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, searchKeyword, selectedStatus, selectedTenant, startDate, endDate, selectedDepartment, selectedAssignee, orderDateSelectedIntervalDateRangeType, selectedFilterView);
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: `${isReturnSlip ? 'RETURN_SLIP' : 'CREDIT_NOTE'}`,
      };
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getDocCFV2(payload);
      const payloadForCN = {
        tenantId: selectedTenant?.filter((item) => !isNaN(item))?.length > 0
          ? selectedTenant?.join(',')
          : Helpers.getTenantEntityPermission(
            user?.user_tenants,
            Helpers.permissionEntities.CREDIT_NOTE,
            Helpers.permissionTypes.READ,
          )?.join(','),
        cnId: '',
        page: Helpers.getValueFromUrl('page'),
        limit: Helpers.getValueFromUrl('limit'),
        customerId: '',
        searchKeyword: Helpers.getValueFromUrl('keyword'),
        status: Helpers.getValueFromUrl('status'),
        startDate: Helpers.getValueFromUrl('startDate'),
        endDate: Helpers.getValueFromUrl('endDate'),
        departmentId: Helpers.getValueFromUrl('department_id'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
        entityType: isReturnSlip ? 'RETURN_SLIP' : 'CREDIT_NOTE'
      };

      getCN(selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.CREDIT_NOTE, Helpers.permissionTypes.READ)?.join(','), '', Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), '', Helpers.getValueFromUrl('keyword'), Helpers.getValueFromUrl('status'),
        Helpers.getValueFromUrl('startDate'), Helpers.getValueFromUrl('endDate'), Helpers.getValueFromUrl('department_id'), Helpers.getValueFromUrl('accountManager'), isReturnSlip ? 'RETURN_SLIP' : 'CREDIT_NOTE', true);
    }
  }, [searchKeyword, currentPage, limit, selectedStatus, selectedTenant, selectedDepartment, startDate, endDate, selectedAssignee, orderDateSelectedIntervalDateRangeType,
    // selectedFilterView
  ]);

  useEffect(() => {
    if (isReturnSlip ? customFieldsPropsReturnSlip?.data?.document_custom_fields?.length : customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = isReturnSlip ? customFieldsPropsReturnSlip?.data?.document_custom_fields : customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-cn'))?.[customField.cf_id]?.visible || false,
        };
      });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps, customFieldsPropsReturnSlip]);

  return (
    <Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder={`Search for ${isReturnSlip ? 'Return Slip' : 'Credit Note'}...`}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.CREDIT_NOTE, Helpers.permissionTypes.CREATE, user) && !isReturnSlip && (
                  <div className="doc-list__buttons-wrapper">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Credit Note"
                      onClick={() => {
                        history.push('/sales/credit-notes/create');
                      }}
                      customClass="add-button"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.startDate = _orderStartDate;
                      filterValue.endDate = _orderEndDate;
                    }

                    filterValue.orderDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;

                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedStatus(tempFilterValues.status);
                    setSelectedTenant(tempFilterValues.tenant);
                    setStartDate(tempFilterValues.startDate);
                    setEndDate(tempFilterValues.endDate);
                    setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                    setSelectedAssignee(tempFilterValues.accountManager);
                    setSelectedDepartment(tempFilterValues.department_id);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={window.location.href.includes('/return-slip') ? entityNameEnum.RETURN_SLIP : entityNameEnum.CREDIT_NOTE}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search for
                    &nbsp;
                    <span><b>{searchKeyword}</b></span>
                  </Tag>
                )}
                {selectedStatus && (
                  <Tag closable onClose={() => { setSelectedStatus(null); setCurrentPage(1); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {
                  (startDate && endDate) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setStartDate(null);
                        setEndDate(null);
                        setOrderDateSelectedIntervalDateRangeType('');
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      From:
                      &nbsp;
                      <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      To:
                      &nbsp;
                      <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }

                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {!!selectedDepartment && (
                  <Tag closable={!departmentLevelVisibility} onClose={() => { setSelectedDepartment(null); setCurrentPage(1); }} color="#2d7df7">
                    {' '}
                    Department -
                    &nbsp;
                    <span><b>{departments?.data?.result?.departments?.find((item) => Number(item?.department_id) === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                  </Tag>
                )}
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${(creditNotes?.data?.count || 0)} ${isReturnSlip ? 'Return Slips' : 'Credit Notes'} Generated`} />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <div className="select-user__filter-wrapper">
                          <SelectUser
                            selectedUsers={selectedAssignee}
                            onSelect={(userId) => {
                              setCurrentPage(1)
                              setSelectedAssignee([...selectedAssignee, {
                                userId,
                                title: userId === 0 ? 'Unassigned' : `${orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name}`?.trim(),
                                identity: userId === 0 ? 'UA' : orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name?.substring(0, 2).toUpperCase(),
                              }]);
                            }}
                            onRemove={(userId) => {
                              setSelectedAssignee([...selectedAssignee?.filter((item) => item?.userId !== userId)]);
                            }}
                          />
                        </div>
                        <H3DateSelector
                          selectedInterval={orderDateSelectedIntervalDateRangeType}
                          startDate={startDate}
                          endDate={endDate}
                          onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                            setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                            setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                            setCurrentPage(1);
                            setOrderDateSelectedIntervalDateRangeType(dateRangeType);
                          }}
                        />
                      </div>
                      <Dropdown
                        trigger={['click']}
                        overlay={(
                          <div className="header__filter__container">
                            <div className="header__filter__container__title">
                              Apply Filters
                            </div>
                            <div
                              className="filter__container"
                            >
                              <div className="filter__title"> Select Business Unit </div>
                              <TenantSelector
                                selectedTenant={selectedTenant}
                                showSearch
                                isMultiple
                                noDropdownAlign
                                onChange={(value) => {
                                  if (value === 'All') {
                                    setCurrentPage(1);
                                    setSelectedTenant(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ).join(','));
                                  } else {
                                    setCurrentPage(1);
                                    setSelectedTenant(value);
                                  }
                                }}
                                placeholder="Select Business Unit"
                                hideTitle
                                includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ)}
                              />
                            </div>
                            <div className="filter__container filter__container-section">
                              <div className="filter__title"> Select Department </div>
                              <SelectDepartment
                                title="Select Department"
                                hideTitle
                                selectedDepartment={Number(selectedDepartment) || ''}
                                noDropdownAlign
                                onChange={(value) => {
                                  setSelectedDepartment(value?.department_id.toString() || '');
                                  setCurrentPage(1);
                                }}
                                disabled={departmentLevelVisibility}
                              />
                            </div>
                            <div
                              className="filter__container"
                            >
                              <div className="filter__title"> Order Status </div>
                              <PRZSelect
                                value={selectedStatus}
                                onChange={(value) => {
                                  setSelectedStatus(value);
                                  setCurrentPage(1);
                                }}
                                placeholder="Order Status"
                                options={cnStatuses}
                              />
                            </div>
                          </div>
                        )}
                      >
                        <div className="doc-list__action-buttons">
                          <div className="action-button">
                            <H3Text text="Filters" className="action-button-text" />
                            <FilterOutlined />
                          </div>
                        </div>
                      </Dropdown>

                      <Dropdown
                        overlay={(
                          <div className="custom-columns__content">
                            <div className="custom-columns__content-section">
                              <H3Text text="Visible Columns" className="custom-columns__content-title" />
                              {
                                Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                  <div key={key}>
                                    <Checkbox
                                      disabled={fixedColumns.includes(key)}
                                      checked={visibleColumns[key]?.visible}
                                      onChange={() => {
                                        const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                        visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                        localStorage.setItem('prcz-page-columns-cn', JSON.stringify(visibleColumnsCopy));
                                        setVisibleColumns(visibleColumnsCopy);
                                      }}
                                    >
                                      {visibleColumns[key]?.label}
                                    </Checkbox>
                                  </div>
                                ))
                              }
                            </div>
                            {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                              <div className="custom-columns__content-section">
                                <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                          localStorage.setItem('prcz-page-columns-cn', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                            ) : ''}
                          </div>
                        )}
                        trigger={['click']}
                        placement="bottomRight"
                      >
                        <div className="custom-columns__wrapper">
                          Customize Columns
                          <ControlOutlined />
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                )}
                loading={getCNLoading || syncSOLoading || getDocCFV2Loading || pushCreditNoteToBusyLoading || savedFilterViewsLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && creditNotes && !!creditNotes?.data?.credit_notes?.length ? { x: 'max-content', y: 'calc(100dvh - 170px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && creditNotes && !!creditNotes?.data?.credit_notes?.length}
                columns={getCreditNoteColumns()}
                dataSource={creditNotes && creditNotes?.data?.credit_notes ? creditNotes?.data?.credit_notes : []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: creditNotes ? creditNotes?.data?.count : 0,
                    pageSize: limit,
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],

                  }
                }
                bordered
              />
            </div>
          </div>
        </div>
      </div>

      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedCreditNote?.invoice_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedCreditNote?.custom_fields}
          documentData={selectedCreditNote}
          fields={ListScreenKeys({
            documentData: selectedCreditNote,
          })}
        />
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, CNReducers, UnicommerceIntegrationReducers, CFV2Reducers, DepartmentReducers, ZohoIntegrationReducers, TallyIntegrationReducers, TenantReducers, BusyIntegrationReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getCNLoading: CNReducers.getCNLoading,
  creditNotes: CNReducers.creditNotes,
  syncSOLoading: UnicommerceIntegrationReducers.syncSOLoading,
  syncCNLoading: ZohoIntegrationReducers.syncCNLoading,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  customFieldsProps: CFV2Reducers.cfV2DocCreditNote,
  customFieldsPropsReturnSlip: CFV2Reducers.cfV2DocReturnSlip,
  departments: DepartmentReducers.departments,
  syncTallyCreditNoteLoading: TallyIntegrationReducers.syncTallyCreditNoteLoading,
  orgUsers: TenantReducers.orgUsers,
  pushCreditNoteToBusyLoading: BusyIntegrationReducers.pushCreditNoteToBusyLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getCN: (tenantId, cnId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, accountManagerIds, docType, is_list) => dispatch(
    CNActions.getCN(tenantId, cnId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, accountManagerIds, docType, is_list),
  ),
  syncSO: (payload, callback) => dispatch(
    UnicommerceIntegrationActions.syncSO(payload, callback),
  ),
  syncCN: (payload, callback) => dispatch(ZohoIntegrationActions.syncCN(payload, callback)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  syncTallyCreditNote: (payload, callback) => dispatch(TallyIntegrationActions.syncTallyCreditNote(payload, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
  getOrgUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
  pushCreditNoteToBusy: (payload, callback) => dispatch(BusyIntegrationActions.pushCreditNoteToBusy(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreditNoteList));
